<template>
  <g class="fill-current">
    <circle cx="10" cy="10" r="9" />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;
  
export default {
  name: "IconCircle",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {
    settings: {
      type: Object
    }
  },
  computed: {}
};
</script>

<style scoped>
</style>